(() => {
  const drawer = document.querySelector('[data-sa-filter-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('[data-sa-filter-panel]');
  const closeButtons = drawer.querySelectorAll('[data-sa-filter-close]');
  const openers = document.querySelectorAll('[data-sa-filter-open]');
  let lastOpener = null;

  const html = document.documentElement;
  const body = document.body;

  const focusFirstClose = () => {
    if (closeButtons.length > 0) {
      closeButtons[0].focus();
    } else if (panel) {
      panel.focus({ preventScroll: true });
    }
  };

  const setExpanded = (expanded) => {
    openers.forEach((btn) => btn.setAttribute('aria-expanded', expanded ? 'true' : 'false'));
    drawer.setAttribute('aria-hidden', expanded ? 'false' : 'true');
  };

  const resetDrawerState = () => {
    drawer.classList.remove('is-open');
    setExpanded(false);
    html.classList.remove('sa-scroll-lock');
    body.classList.remove('sa-scroll-lock');
    html.classList.remove('sa-filter-open');
    lastOpener = null;
  };

  const openDrawer = (trigger) => {
    lastOpener = trigger || null;
    drawer.classList.add('is-open');
    setExpanded(true);
    html.classList.add('sa-scroll-lock');
    body.classList.add('sa-scroll-lock');
    html.classList.add('sa-filter-open');
    focusFirstClose();
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    setExpanded(false);
    html.classList.remove('sa-scroll-lock');
    body.classList.remove('sa-scroll-lock');
    html.classList.remove('sa-filter-open');
    if (lastOpener) {
      lastOpener.focus({ preventScroll: true });
      lastOpener = null;
    }
  };

  openers.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      openDrawer(btn);
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      closeDrawer();
    });
  });
  
  document.addEventListener('click', (event) => {
    if (!drawer.classList.contains('is-open')) return;
    const target = event.target;
    if (panel && panel.contains(target)) return;
    if (target.closest('[data-sa-filter-open]')) return;
    closeDrawer();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* Accordion toggles inside drawer */
  drawer.querySelectorAll('[data-sa-filter-accordion]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.nextElementSibling;
      if (!target) return;
      const isOpen = !target.hidden;
      target.hidden = isOpen;
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  resetDrawerState();

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      resetDrawerState();
    }
  });
})();
